module.exports = __webpack_public_path__ + "static/img/red_clock.892de583.svg";